/** Constrain horizontal travel from the leading square back through each row. */
export function constrainHeroRowTravel({squares, gap}) {
    const offsets = squares.map(() => 0);
    const rows = new Map();
    squares.forEach((square, index) => {
        if (!rows.has(square.row)) rows.set(square.row, []);
        rows.get(square.row).push({...square, index});
    });
    for (const [row, items] of rows) {
        const direction = row % 2 === 0 ? 1 : -1;
        items.sort((a, b) => direction * (b.left - a.left));
        items.forEach((square, index) => {
            let distance = square.travel;
            if (index > 0) {
                const ahead = items[index - 1];
                const clearance = direction > 0 ?
                    ahead.left - square.left - square.width :
                    square.left - ahead.left - ahead.width;
                // Keep half the gutter free even at full scroll displacement.
                distance = Math.min(distance, Math.abs(offsets[ahead.index]) + Math.max(0, clearance - gap / 2));
            }
            offsets[square.index] = direction * distance;
        });
    }
    return offsets;
}
